export default __webpack_public_path__ + "static/media/lk-dropdown-icon.b8c9be51.svg";